export default {
  truncateTypography: { width: 250 },
  actionButtonContainer: { textAlign: 'right' },
};

